import { UserRoleId } from '@/types/authorisation/role-id.enum'

export function authorizeFactory() {
  function getFormsUser() {
    return {
      forms: true,
    }
  }

  function getFuelDataContributor() {
    return {
      allowedRolesExplicit: [UserRoleId.FuelDataContributor, UserRoleId.SiteFuelDataContributor],
      disallowedRedirectTo: 'summary',
    }
  }

  function getOrganisationAdmin() {
    return {
      allowedMinimumRole: UserRoleId.OrganisationAdmin,
    }
  }

  function getOrganisationUser() {
    return {
      allowedMinimumRole: UserRoleId.OrganisationUser,
      disallowedRedirectTo: 'summary',
    }
  }

  function getPartnerAdmin() {
    return {
      allowedMinimumRole: UserRoleId.PartnerAdmin,
    }
  }

  function getPartnerTechnician() {
    return {
      allowedRolesExplicit: [UserRoleId.PartnerTechnician],
      disallowedRedirectTo: 'app',
    }
  }

  function getSiteMonitorReadingsUser() {
    return {
      allowedRolesExplicit: [UserRoleId.OrganisationAdmin, UserRoleId.PartnerAdmin],
      disallowedRedirectTo: 'app',
    }
  }

  function getSiteUser() {
    return {
      allowedMinimumRole: UserRoleId.SiteUser,
    }
  }

  function getSysAdmin() {
    return {
      allowedRolesExplicit: [UserRoleId.SysAdmin],
      disallowedRedirectTo: 'app',
    }
  }

  return {
    getFormsUser,
    getFuelDataContributor,
    getOrganisationAdmin,
    getOrganisationUser,
    getPartnerAdmin,
    getPartnerTechnician,
    getSiteMonitorReadingsUser,
    getSiteUser,
    getSysAdmin,
  }
}
